module.exports = __webpack_public_path__ + "media/images/official/removeanxieties_icon_staff-9b8b3679a8d0a004ad38e2b639569319.svg";